'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.beginningOfMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/beginningOfMonth.js
// module id = 478
// module chunks = 0